import { render } from "./FileViewerModal.vue?vue&type=template&id=18d2fb9f&scoped=true"
import script from "./FileViewerModal.vue?vue&type=script&lang=js"
export * from "./FileViewerModal.vue?vue&type=script&lang=js"

import "./FileViewerModal.vue?vue&type=style&index=0&id=18d2fb9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d2fb9f"]])

export default __exports__